import type { EpisodeComment, EpisodeCommented, EpisodeCommentsContext } from '@/_contract/episodeComments';

export function parseEpisodeComments(value: unknown): EpisodeCommented {
    if (value === undefined) return {};
    if (!Array.isArray(value) || value.length > 100) throw new Error('Comments must be an array of at most 100 entries.');
    const ids = new Set<string>();
    const comments: EpisodeComment[] = value.map(comment => {
        if (!comment || typeof comment !== 'object' || Array.isArray(comment)
            || Object.keys(comment).some(key => key !== 'id' && key !== 'text')
            || typeof comment.id !== 'string' || !/^[a-z][a-z0-9-]{0,99}$/.test(comment.id)
            || typeof comment.text !== 'string' || !comment.text.trim() || comment.text.length > 10000) {
            throw new Error('Each comment requires an id and nonempty text (at most 10000 characters).');
        }
        if (ids.has(comment.id)) throw new Error(`Duplicate comment '${comment.id}'.`);
        ids.add(comment.id);
        return { id: comment.id, text: comment.text };
    });
    return { comments };
}

export function episodeCommentsContext(
    episode: EpisodeCommented & { handle: string; scenes: readonly (EpisodeCommented & {
        id: string; title: string; beats: readonly (EpisodeCommented & { id: string })[];
    })[] }, sceneIndex: number, beatIndex: number,
): EpisodeCommentsContext {
    const scene = episode.scenes[sceneIndex];
    const beat = scene?.beats[beatIndex];
    if (!scene || !beat) throw new Error('Comments require an existing scene and beat.');
    return { handle: episode.handle, groups: [
        { label: 'Episode', comments: episode.comments ?? [] },
        { label: `Scene: ${scene.title}`, sceneId: scene.id, comments: scene.comments ?? [] },
        { label: `Beat: ${beat.id}`, sceneId: scene.id, beatId: beat.id, comments: beat.comments ?? [] },
    ] };
}
